export enum LocalStoreKeys {
    AccessToken = 'access-token',
}

